import React from 'react'
import VideoControl from './buttons-controls/VideoControl'
import VolumeControl from './player-volume/VolumeControl'
import PlayerProgressBar from './player-progress-bar/PlayerProgressBar'
import {
  StyledControlsWrapper,
  StyledVideoTitle,
  StyledButtons,
  StyledControls,
} from './ControlsWrapper.style'

export interface IControlsWrapper {
  videoRef: React.RefObject<HTMLVideoElement>
  videoTitle: string
  isPlaying: boolean
  onPlayPause: () => void
  setIsPlaying: React.Dispatch<React.SetStateAction<boolean>>
  currentTime: number
  duration: number
  setCurrentTime: React.Dispatch<React.SetStateAction<number>>
  isFadeIn: boolean
}

export const ControlsWrapper = ({
  videoRef,
  videoTitle,
  isPlaying,
  onPlayPause,
  setIsPlaying,
  currentTime,
  duration,
  setCurrentTime,
  isFadeIn,
}: IControlsWrapper): JSX.Element => {
  return (
    <StyledControlsWrapper isFadeIn={isFadeIn}>
      <StyledVideoTitle data-type="video-title">{videoTitle}</StyledVideoTitle>
      <PlayerProgressBar
        videoRef={videoRef}
        isPlaying={isPlaying}
        setIsPlaying={setIsPlaying}
        setCurrentTime={setCurrentTime}
        duration={duration}
        currentTime={currentTime}
      />
      <StyledButtons>
        <StyledControls>
          <VideoControl
            videoRef={videoRef}
            onPlayPause={onPlayPause}
            isPlaying={isPlaying}
            duration={duration}
            setCurrentTime={setCurrentTime}
            setIsPlaying={setIsPlaying}
          />
        </StyledControls>
        <VolumeControl videoRef={videoRef} />
      </StyledButtons>
    </StyledControlsWrapper>
  )
}

export default ControlsWrapper
